import { api } from "../../api/client";

export type PerformanceRating = "excellent" | "good" | "satisfactory" | "poor" | "failing";
export type Classification = "unclassified" | "restricted" | "secret";

export interface PerformanceReport {
  id: string;
  reporterUid: string;
  subjectUid: string;
  branchId: string;
  wardId: string | null;
  constituencyId: string | null;
  rating: PerformanceRating;
  reasons: string;
  recommendations: string;
  classification: Classification;
  createdAt: string;
}

interface List<T> { items: T[]; }

export interface PerformanceCreate {
  subjectUid: string;
  branchId: string;
  pollingStationId?: string;
  rating: PerformanceRating;
  reasons: string;
  recommendations?: string;
  classification?: Classification;
  sourcesCount?: number;
  confidenceScore?: number;
}

export const PerformanceApi = {
  list: (filters?: { rating?: PerformanceRating; branchId?: string; subjectUid?: string }) => {
    const qs = new URLSearchParams();
    if (filters?.rating) qs.set("rating", filters.rating);
    if (filters?.branchId) qs.set("branchId", filters.branchId);
    if (filters?.subjectUid) qs.set("subjectUid", filters.subjectUid);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return api<List<PerformanceReport>>(`/performance-reports${suffix}`);
  },
  get: (id: string) => api<PerformanceReport>(`/performance-reports/${id}`),
  create: (body: PerformanceCreate) =>
    api<PerformanceReport>("/performance-reports", { method: "POST", body: JSON.stringify(body) }),
  myReports: () => api<List<PerformanceReport>>("/me/performance-reports"),
};
